import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMap, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import { motion } from "framer-motion";
import { MAP_CONFIG, MINERAL_LOCATIONS } from '../Data';

// Custom Diamond Marker Icon
const diamondIcon = new L.DivIcon({
  className: 'diamond-marker',
  iconSize: [12, 12],
  iconAnchor: [6, 6]
});

// Map Controller
function MapController({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    map.flyTo(center, zoom, { duration: 2 });
  }, [center, zoom, map]);
  return null;
}

const MineralMap = () => {
  const [activeTab, setActiveTab] = useState('africa');

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.7,
        ease: "easeOut"
      }
    })
  };

  return (
    <div className="mineral-map-section container">

      {/* HEADING */}
      <motion.h2
        className="section-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
        Global Supply of Bentonite & Industrial Mineral Products
      </motion.h2>

      {/* DESCRIPTION */}
      <motion.p
        className="section-text"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
    From Gandhidham, Kutch, Gujarat, India to markets across the globe, <b className='bold'>Iris Impulse India Pvt. Ltd.</b> supplies industrial minerals that power diverse industries. Our products contribute to Paper, Civil Engineering, Foundries, Steel - IOP, Drilling, Pet Industries, Refractories & Many More sectors, creating a positive impact worldwide through quality, reliability, and innovation.
      </motion.p>

      {/* TABS */}
      <motion.div
        className="tabs"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {Object.keys(MAP_CONFIG).map((cont, i) => (
          <motion.button
            key={cont}
            custom={i}
            variants={fadeUp}
            className={activeTab === cont ? 'active' : ''}
            onClick={() => setActiveTab(cont)}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
          >
            {MAP_CONFIG[cont].label.toUpperCase()}
          </motion.button>
        ))}
      </motion.div>

      {/* MAP WRAPPER */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <MapContainer
          center={MAP_CONFIG.africa.center}
          zoom={MAP_CONFIG.africa.zoom}
          scrollWheelZoom={false}
          className="leaflet-container"
        >

          <TileLayer
url={`https://{s}.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}.png?key=${process.env.REACT_APP_CARTO_API_KEY}`}
attribution='&copy; OpenStreetMap contributors &copy; CARTO'
/>

          <MapController
            center={MAP_CONFIG[activeTab].center}
            zoom={MAP_CONFIG[activeTab].zoom}
          />

         {MINERAL_LOCATIONS
  .filter((loc) => loc.continent === activeTab)
  .map((loc, i) => (
    <Marker key={loc.id} position={loc.coords} icon={diamondIcon}>
      <Tooltip 
        direction="top" 
        offset={[0, -10]} 
        opacity={1} 
        permanent={false}
      >
        <span className="map-tooltip-text">{loc.name}</span>
      </Tooltip>
    </Marker>
  ))}
        </MapContainer>
      </motion.div>

    </div>
  );
};

export default MineralMap;